export const scrollToElement = (itemId: string, delay: number = 300): void => {
  setTimeout(() => {
    const element = document.getElementById(itemId);
    if (element) {
      const rect = element.getBoundingClientRect();
      const viewportHeight =
        window.innerHeight || document.documentElement.clientHeight;
      const viewportWidth =
        window.innerWidth || document.documentElement.clientWidth;

      const isVisible =
        rect.top < viewportHeight &&
        rect.bottom > 0 &&
        rect.left < viewportWidth &&
        rect.right > 0;

      if (!isVisible && typeof element.scrollIntoView === 'function') {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest',
        });
      }
      if (typeof element.focus === 'function') {
        element.focus();
      }
    }
  }, delay);
};
